import React from 'react';

import { useRouter } from '@/navigation';

import { Button } from '@/components/ui';

import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

type UpsellCardProps = {
  headerText: string;
  subText: React.ReactNode;
  ctaText: string;
  ctaLink: string;
  children?: React.ReactNode;
  onClick?: () => void;
};

const UpsellCard: React.FC<UpsellCardProps> = ({
  headerText,
  subText,
  ctaText,
  ctaLink,
  children,
  onClick,
}) => {
  const { push } = useRouter();

  const handleClick = () => {
    onClick?.();

    push(ctaLink);
  };

  return (
    <div className="rounded-md p-8 mb-10 shadow-lg flex md:flex-row flex-col gap-6 md:items-center md:justify-between">
      <div>
        <Heading
          tag={HeadingTag.H2}
          size={HeadingSize.H2}
          classes="pb-2"
          align="left"
          text={headerText}
        />

        {subText && <div className="text-left md:pr-3">{subText}</div>}
      </div>

      <Button ctaText={ctaText} onClick={() => handleClick()} />

      {children}
    </div>
  );
};
export default UpsellCard;
